import React from "react";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const InvoiceDetailComponent = loadable(
  () => import("../../components/Invoice/InvoiceDetail")
);
const InvoiceDetail = () => {
  const { id } = useParams();

  const { data: order } = useGetHook({
    queryKey: ["invoice-details"],
    url: `${APIS.INVOICE}${id}/`,
    params: {},
  });

  return (
    <>
      <div
        className={tw`w-full sha flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Invoice Details
        </span>
      </div>
      <InvoiceDetailComponent order={order} id={id} />
    </>
  );
};

export default InvoiceDetail;
